import React from 'react'
import { IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import type { CartItem } from '../../providers/Cart'
import { QuantityHoursControls } from '../QuantityHoursControls'

type Props = {
  item: CartItem
  hourlyRate?: number
  onUpdate: (patch: Partial<CartItem>) => void
  onRemove: () => void
}

const formatCurrency = (n: number) =>
  n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

export const LineItem: React.FC<Props> = ({
  item,
  hourlyRate,
  onUpdate,
  onRemove,
}) => {
  const lineTotal =
    hourlyRate != null ? hourlyRate * item.hours * item.quantity : null

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: 'flex-start',
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'common.black',
      }}
    >
      <Stack spacing={1.5} sx={{ flex: 1 }}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'baseline', justifyContent: 'space-between' }}
        >
          <Stack direction="row" spacing={1} sx={{ alignItems: 'baseline' }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {item.skillName}
            </Typography>
            {hourlyRate != null && (
              <Typography
                sx={{ color: 'primary.main', fontSize: 12, fontWeight: 600 }}
              >
                {formatCurrency(hourlyRate)}/hr
              </Typography>
            )}
          </Stack>
          <Typography variant="body2" sx={{ fontWeight: 800 }}>
            {lineTotal != null ? formatCurrency(lineTotal) : '—'}
          </Typography>
        </Stack>

        <QuantityHoursControls
          quantity={item.quantity}
          hours={item.hours}
          onQuantityChange={(quantity) => onUpdate({ quantity })}
          onHoursChange={(hours) => onUpdate({ hours })}
        />
      </Stack>
      <IconButton
        size="small"
        aria-label={`Remove ${item.skillName}`}
        onClick={onRemove}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Stack>
  )
}
